import { CircleCheck } from 'lucide-react';
import type { ForgotSuccessStepProps } from '../types';
import { ResendButton, BackToLoginLink, InfoBox } from '../shared';

/**
 * 忘记密码发送成功步骤页面
 */
export function ForgotSuccessStep({
  email,
  resendCountdown = 0,
  loading = false,
  onResendClick,
  onStepChange,
}: ForgotSuccessStepProps) {
  /**
   * 格式化倒计时显示
   */
  const formatCountdown = (seconds: number) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${String(mins).padStart(2, '0')}:${String(secs).padStart(2, '0')}`;
  };

  return (
    <div className="flex w-full flex-col gap-[24px]">
      {/* 标题区域 */}
      <div className="flex flex-col items-center gap-[16px]">
        <div className="flex items-center gap-[8px]">
          <CircleCheck className="h-[28px] w-[28px] text-[#10b981]" />
          <h2 className="text-[24px] font-semibold leading-[1.2] tracking-[-0.48px] text-[#10b981]">Success</h2>
        </div>
      </div>

      {/* 提示信息 */}
      <InfoBox>
        <p className="text-[16px] font-medium leading-[1.5] text-[#262626]">
          A password reset link has been sent to: {email}
        </p>
        <div className="flex flex-col gap-[12px]">
          <p>Please check your inbox and follow the instructions to reset your password.</p>
          <p>If you don't see it, please check your spam folder.</p>
        </div>
      </InfoBox>

      {/* 重发按钮 */}
      <ResendButton
        countdown={resendCountdown}
        formattedTime={formatCountdown(resendCountdown)}
        onClick={onResendClick}
        loading={loading}
      />

      {/* 返回登录 */}
      <div className="flex justify-center">
        <BackToLoginLink onClick={() => onStepChange?.('login')} />
      </div>
    </div>
  );
}

export default ForgotSuccessStep;
